import { isPlatformBrowser } from '@angular/common';
import { Component, DestroyRef, inject, Inject, Input, OnInit, PLATFORM_ID, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ParamFilters } from '@app/models/filtermodels/ParamFilters';
import { Partner } from '@app/models/partner/IPartner';
import { AuthGuardService } from '@app/services/auth-guard.service';
import { HotelFiltersService } from '@app/services/hotelfilters.service';

@Component({
    selector: 'clever-price',
    templateUrl: './price.component.html',
    styleUrls: ['./price.component.scss'],
    standalone: false
})
export class PriceComponent implements OnInit {
    destroyRef = inject(DestroyRef);
    maxPricePerPerson = signal<number>(10000);
    minPricePerPerson = signal<number>(0);
    @Input() mode: string;
    currentpartner: Partner;

    showPrice = signal<boolean>(false);
    isBrowser = signal<boolean>(false);

    constructor(
        @Inject(PLATFORM_ID) protected platformId: any,
        protected hotelService: HotelFiltersService,
        protected guardService: AuthGuardService
    ) {
        this.isBrowser.set(isPlatformBrowser(this.platformId));
    }

    ngOnInit(): void {
        this.initPartnerSub();
        if (this.isBrowser()) {
            this.initFilterSub();
        }
    }

    initPartnerSub(): void {
        this.guardService.getPartner$.pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe(partner => {
            if (partner?.partnerid?.length > 0) {
                this.currentpartner = partner;
            }
        });
    }

    async dblpricechange(ev) {
        this.hotelService.price(ev, this.mode !== 'home');
    }

    initFilterSub(): void {
        this.hotelService.getfilters$.pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe((filter: ParamFilters) => {
            if (this.maxPricePerPerson() !== filter?.maxPricePerPerson || this.minPricePerPerson() !== filter?.minPricePerPerson) {
                this.showPrice.set(false);

                this.maxPricePerPerson.set(filter?.maxPricePerPerson);
                this.minPricePerPerson.set(filter?.minPricePerPerson);
                setTimeout(() => {
                    this.showPrice.set(true);
                });
            }
        });
    }
}
